import React, { useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  dir: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  strings: PropTypes.shape({
    submit: PropTypes.string,
  }).isRequired,
};

const EssayQuestion = ({
  dir = null,
  onSubmit,
  question,
  strings,
}) => {
  const [answer, setAnswer] = useState('');

  const handleChange = event => {
    setAnswer(event.target.value);
  };

  const handleClick = () => {
    onSubmit(question.id, { text: answer });
  };

  return (
    <div className="question" dir={dir}>
      <p className="question__body">{question.text}</p>

      <div className="question__answers">
        <textarea
          className="form-control"
          onChange={handleChange}
          value={answer}
        />
        <button
          className="question__btn"
          onClick={handleClick}
          type="button"
        >
          {strings.submit}
        </button>
      </div>
    </div>
  );
};

EssayQuestion.propTypes = propTypes;

export default EssayQuestion;
